module.exports = __webpack_public_path__ + "img/cgqlc.d9eda96e.png";